import { render, staticRenderFns } from "./InsurancesPlanEdit.vue?vue&type=template&id=f51f8518&scoped=true&"
import script from "./InsurancesPlanEdit.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51f8518",
  null
  
)

export default component.exports